module.exports = __webpack_public_path__ + "static/media/product-manufacturing-gif.b5f7d568.gif";